export default function ElaLogo({ width = '15vw', height = '5vw' }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 125 40"
      xmlSpace="preserve"
    >
      <style>{`
        .logo-st1 {
          fill: none;
          stroke: #131548;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 10;
          stroke-width: 2;
        }
        .logo-st2 {
          stroke: #F52E72;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 10;
          stroke-width: 2;
          fill: none;
        }
      `}</style>
      <g>
        <line className="logo-st1 letter-e" x1="9.82" y1="3.75" x2="44.31" y2="3.75" />
        <line className="logo-st1 letter-e" x1="9.82" y1="38.25" x2="44.31" y2="38.25" />
        <line className="logo-st1 letter-e" x1="25.38" y1="19.32" x2="28.75" y2="22.68" />
        <line className="logo-st1 letter-e" x1="28.75" y1="19.32" x2="25.38" y2="22.68" />
      </g>
      <g>
        <polyline className="logo-st1 letter-l" points="87.26,38.25 52.76,38.25 52.76,3.75" />
      </g>
      <g>
        <polyline className="logo-st1 letter-a" points="86.47,3.75 120.96,3.75 120.96,38.25" />
        <line className="logo-st2 letter-a" x1="102.03" y1="19.32" x2="105.4" y2="22.68" />
        <line className="logo-st2 letter-a" x1="105.4" y1="19.32" x2="102.03" y2="22.68" />
      </g>
    </svg>
  );
}
